module.exports = __webpack_public_path__ + "img/logo.6207d246.png";